import firebase from '../../firebase/compat';

// De Cloud Function weigert meer dan 500 strings per aanroep; blijf daar ruim onder.
const CALL_CHUNK_LIMIT = 400;

const chunk = (arr, size) => {
    const out = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
};

/**
 * Vertaalt een set strings in één aanroep per blok.
 *
 * Vervangt het per-string vertalen: een vragenlijst met veel vragen en
 * antwoordopties kostte zo 100+ round trips per taalwissel. De Cloud Function
 * ontdubbelt en cachet, dus een taal die al eerder gebruikt is komt er meteen uit.
 *
 * @param {{texts: string[], languageCode: string}} params
 * @returns {Promise<string[]>} Vertalingen op dezelfde volgorde als `texts`
 */
const translateStrings = async ({ texts, languageCode }) => {
    // Nederlands is de brontaal, en zonder taalcode valt de pagina terug op de bron.
    if (!languageCode || languageCode === 'nl') return texts;
    if (!texts || texts.length === 0) return [];

    const translateTexts = firebase.app().functions('europe-west1').httpsCallable('translateTexts');

    const results = [];

    for (const batch of chunk(texts, CALL_CHUNK_LIMIT)) {
        const result = await translateTexts({ texts: batch, targetLanguage: languageCode });
        results.push(...result.data.translations);
    }

    return results;
};

export { CALL_CHUNK_LIMIT };
export default translateStrings;
